import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import TextField from "@material-ui/core/TextField";

import appRoutes from "../../../routes/app.routes";
import { HERO_FLOAT_CARDS } from "../homeV2.constants";
import HvButton from "./HvButton";

const Hero = () => {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [location, setLocation] = useState("");

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    navigate(appRoutes.candidateJobSearch.path);
  };

  return (
    <section className="hv2-hero" id="hero">
      <div className="home-v2__container hv2-hero__grid">
        <div className="hv2-hero__content">
          <span className="hv2-hero__badge">
            <span className="hv2-hero__badge-dot" aria-hidden="true" />
            Powered by Suhavi AI
          </span>
          <h1 className="home-v2__h1 hv2-hero__headline">
            Be seen. Not
            <br />
            <span className="home-v2__highlight hv2-hero__headline-italic">screened</span>
          </h1>
          <p className="home-v2__body-lg hv2-hero__sub">
            employHER swaps the resume screen for a 60-second video profile. Hiring teams meet you
            before a keyword filter decides for them. Free to join, free to stay.
          </p>
          {/* No separate "Find Jobs" button here — the search bar below is
              the job-search entry point, so a second "find jobs" CTA this
              close to it read as redundant (feedback: two near-identical
              pink buttons stacked on mobile). "Join employHER" takes the
              primary button slot instead. */}
          <div className="hv2-hero__ctas">
            <HvButton variant="primary" to={appRoutes.userSignUp.path}>
              Join employHER →
            </HvButton>
          </div>
          <div className="hv2-hero__hiring-link">
            <Link to={appRoutes.salesInquiry.generatePath()} className="hv2-btn-text hv2-btn-text--muted">
              Hiring? Find talent →
            </Link>
          </div>
          <form className="hv2-hero__search" onSubmit={handleSearch}>
            <TextField
              className="hv2-hero__search-input"
              placeholder="Job title, skill or company"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{ disableUnderline: true }}
            />
            <TextField
              className="hv2-hero__search-input"
              placeholder="City, state or remote"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              InputProps={{ disableUnderline: true }}
            />
            <HvButton variant="primary" type="submit">
              Search Jobs →
            </HvButton>
          </form>
        </div>

        <div className="hv2-hero-visual" aria-hidden="true">
          <div className="hv2-recording-card">
            <div className="hv2-recording-card__top">
              <div className="hv2-recording-card__rec">
                <span className="hv2-recording-card__rec-dot" /> REC
              </div>
              <div className="hv2-recording-card__timer">00:47 / 01:00</div>
            </div>
            <div className="hv2-recording-card__initials">AO</div>
            <div className="hv2-recording-card__bottom">
              <div>
                <div className="hv2-recording-card__name">Amara Okafor</div>
                <div className="hv2-recording-card__role">Senior Product Designer</div>
              </div>
              <div className="hv2-recording-card__views">87% viewed</div>
            </div>
          </div>

          {HERO_FLOAT_CARDS.map((card) => (
            <div className={`hv2-float-card hv2-float-card--${card.id}`} key={card.id}>
              <span className={`dot ${card.dot !== "default" ? `dot--${card.dot}` : ""}`} />
              {card.text}
              {card.strong && <strong style={{ fontWeight: 600 }}> {card.strong}</strong>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
